import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { ApplicationInsightsService } from '../services/application-insights.service';

/**
 * Registration form for the "Flow Studio MCP Server" live webinar.
 *
 * TODO(21 Sep webinar): still the AUGUST form. Replace before this reaches production —
 * bumping the slug below re-shows the popup to every user, so shipping it with a stale
 * link invites everyone to register for a webinar that has already happened.
 */
export const WEBINAR_LINK = 'https://forms.cloud.microsoft/r/F7LFEsQ40V';

/**
 * Bump this slug for the next webinar. It is the localStorage key suffix, so a
 * new value re-arms the show-once-automatically gate for every user.
 */
export const WEBINAR_SLUG = 'webinar-2026-09-mcp';

/** Displayed over the date-free poster artwork so future dates stay editable in code. */
export const WEBINAR_DATE_LABEL = 'Monday 21 September 2026';

/**
 * Promo disappears (auto-show and header button) once the webinar is over.
 *
 * A UTC INSTANT, not a local date. The webinar is 21 Sep 2026, 7:00 AM Pacific = 14:00 UTC,
 * which is midnight on the 22nd in Sydney and 3 PM in London. The previous
 * `new Date(2026, 7, 18)` form was evaluated in the BROWSER's timezone, so an Australian
 * viewer lost the promo at the exact hour the session started. This expires at the same real
 * moment for everyone: 16:00 UTC, two hours after the start.
 */
export const WEBINAR_END = new Date(Date.UTC(2026, 8, 21, 16, 0, 0));

export const WEBINAR_SEEN_KEY = `flowstudio.promo.${WEBINAR_SLUG}`;

/** True while the webinar is still upcoming — drives both the auto-show and the header button. */
export function isWebinarActive(): boolean {
    return Date.now() < WEBINAR_END.getTime();
}

@Component({
    selector: 'app-webinar-promo',
    templateUrl: './webinar-promo.component.html',
    styleUrl: './webinar-promo.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WebinarPromoComponent {

    public readonly link = WEBINAR_LINK;
    public readonly dateLabel = WEBINAR_DATE_LABEL;

    constructor(
        @Optional() public dialogRef: DialogRef,
        private appInsights: ApplicationInsightsService
    ) {}

    public register(): void {
        this.appInsights.trackEvent('webinar-promo', { action: 'register', slug: WEBINAR_SLUG });
        window.open(this.link, '_blank', 'noopener,noreferrer');
        this.close();
    }

    public close(): void {
        this.dialogRef?.close();
    }
}
